import Vuex from 'vuex';
import Vue from 'vue';
import axios from 'axios';
import _ from 'lodash';
import { withoutNoData } from './noData';
// import moment from 'moment-timezone';


var _API_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiRGV2ZWxvcG1lbnQgdG9rZW4iLCJwbGF0Zm9ybSI6ImRldiIsImFwcCI6IkRldmVsb3BtZW50In0.QXkohQ7lHeuS71xdcQJWa9_krUjtxFI4s1BqF1FkvW0';
var _BASE_URL_GEO = 'https://api.agroclimate.org/v2/geo/location/';

var _BASE_URL_LEGEND = 'https://api.agroclimate.org/v2/map/legend/variable/'; // https://cloud.agroclimate.org/api/gps/v1/spatial/legend/variable/';
var _BASE_URL_PIXEL = 'https://api.agroclimate.org/v2/indicators/';
// Prod URL baked in, like the rest of this file. VUE_APP_MODEL_API_URL is a dev-time
// override (.env.development.local points it at the /model-api proxy -> localhost:5001).
var _BASE_URL_PIXEL_MODEL = (process.env.VUE_APP_MODEL_API_URL || 'https://models.agroclimate.org') + '/model/';
let activeRequestController = null;

//load Vuex
Vue.use(Vuex);

//to handle state
const state = {

    /*
    * Menu
    */

    menuSettings: { geoid: '', variable: { id: '', unit: '', layer: 1, threshold: '', description: '' }, period: { period: '' } },

    menuLocale: { geoid: '', description: '' },

    menuVariable: { id: '', threshold: '' },

    menuPeriod: { period: '', begin: '', end: '' },

    latLonInfo: {},

    /*
     * Data Visualization an Map Pin control
    */
    dataAnalysisStatus: false,
    dataAnalysisFullScreen: false,
    dropPinStatus: false,

    dataLoading: false,
    // Requests a tab started on its own (e.g. on being opened), tracked through
    // trackLoading so the same pre-loader shows while they run. A counter, not a
    // flag: several can overlap and the first to finish must not hide it.
    pendingLoads: 0,

    /*
     * Map Status
    */
    mapConfigOne: {
        url: '',
        layer: '',
        visibility: true
    },
    mapConfigTwo: {
        url: '',
        layer: '',
        visibility: false
    },

    mapLegend: { map1: { colors: [], values: [], layer: '' }, map2: { colors: [], values: [], layer: '' } },

    mapLatLon: { latitude: null, longitude: null },

    pixelData: [],

    pixelDataHis: [],

    pixelAnomalyData: [],

    all5Years: [],

    pixelStats: [],

    pixelSeasonSummary: [],


    /*
    * Alerts control
    */
    alerts: [],
}

//to handle state
const getters = {

    /*
     * Map Mode Control
    */

    getMapLegend: state => variable => _.cloneDeep(state.mapLegend).find(
        (v) => v.id_variable == variable
    ),

}

//to handle actions
const actions = {

    startNewDataRequest() {
        // 1. If a previous request is running, kill it
        if (activeRequestController) {
            activeRequestController.abort();
        }
        // 2. Create a fresh controller for the new request
        activeRequestController = new AbortController();
    },


    getGeoInfo({ commit }, latlon) {
        axios
            .get(
                _BASE_URL_GEO + 'latlon/' + latlon.latitude + ',' + latlon.longitude, {
                headers: { 'x-api-key': _API_KEY }
            }
            )
            .then(response => {
                // console.log('response: ', response)
                if (response.data.code == 'SUCCESS')
                    commit('SET_GEO_INFO', response.data.data);
            })
            .catch(e => {
                console.log(e);
                commit('SET_GEO_INFO', undefined);
            });
    },

    /*
    * HTTP Requests
    */
    getLegend({ commit }, { variable, map }) {

        var unit = state.menuSettings.variable.unit
        if (state.menuSettings.variable.unit == '' && state.menuSettings.variable.description != '') {
            unit = 'f';
            // commit('SET_MAP_LEGEND', undefined);
            //return;
        }

        if (variable.substring(0, 2) == 'hi') {
            let cm;
            if (variable == 'hi') {
                cm = {"color_map": {"1": "#5a0f7d", "2": "#7a0f78", "3": "#96116a", "4": "#a01356", "5": "#b21b4b", "6": "#c22740", "7": "#d03636", "8": "#dd472c", "9": "#e85822", "10": "#f06a17", "11": "#f57e0f", "12": "#f8930f", "13": "#f9a81c", "14": "#f9bd2d", "15": "#f9d13e", "16": "#fadf5b", "17": "#fbe97e", "18": "#fbf3a8", "19": "#dfded1", "20": "#d6dbd8", "21": "#ccd6dc", "22": "#c3d0da"}, "range_map": {"1": {"min": 135, "max": 200}, "2": {"min": 129, "max": 135}, "3": {"min": 125, "max": 129}, "4": {"min": 121, "max": 125}, "5": {"min": 117, "max": 121}, "6": {"min": 114, "max": 117}, "7": {"min": 110, "max": 114}, "8": {"min": 107, "max": 110}, "9": {"min": 103, "max": 107}, "10": {"min": 100, "max": 103}, "11": {"min": 97.5, "max": 100}, "12": {"min": 95, "max": 97.5}, "13": {"min": 92.5, "max": 95}, "14": {"min": 90, "max": 92.5}, "15": {"min": 87.5, "max": 90}, "16": {"min": 85, "max": 87.5}, "17": {"min": 82.5, "max": 85}, "18": {"min": 80, "max": 82.5}, "19": {"min": 70, "max": 80}, "20": {"min": 61, "max": 70}, "21": {"min": 50, "max": 61}, "22": {"min": -100, "max": 50}}};
            } else {
                cm = {"color_map": {"1": "#5e116b", "2": "#75176c", "3": "#8a1d69", "4": "#9d2361", "5": "#af2b56", "6": "#bf344a", "7": "#cd403e", "8": "#da4d33", "9": "#e55b2a", "10": "#ee6a20", "11": "#f57a14", "12": "#fa8b0b", "13": "#fb9c0d", "14": "#fcad25", "15": "#fbbf3d", "16": "#fbd152", "17": "#fce269", "18": "#fef18c", "19": "#fffcbc", "20": "#eeece4"}, "range_map": {"1": {"min": 2400, "max": 99999}, "2": {"min": 1600, "max": 2400}, "3": {"min": 1000, "max": 1600}, "4": {"min": 640, "max": 1000}, "5": {"min": 400, "max": 640}, "6": {"min": 250, "max": 400}, "7": {"min": 160, "max": 250}, "8": {"min": 100, "max": 160}, "9": {"min": 64, "max": 100}, "10": {"min": 40, "max": 64}, "11": {"min": 25, "max": 40}, "12": {"min": 16, "max": 25}, "13": {"min": 10, "max": 16}, "14": {"min": 6, "max": 10}, "15": {"min": 4, "max": 6}, "16": {"min": 2.5, "max": 4}, "17": {"min": 1.5, "max": 2.5}, "18": {"min": 1, "max": 1.5}, "19": {"min": 0.5, "max": 1}, "20": {"min": 0, "max": 0.5}}};
            }
            cm['id_variable'] = variable;
            cm['map'] = map;
            commit('SET_MAP_LEGEND', cm);

        } else if (variable == 'lwt') {
            let cm = {"color_map": {"1": "#0b3d78", "2": "#144a87", "3": "#1d5897", "4": "#2666a5", "5": "#2b72ad", "6": "#2979a6", "7": "#27809f", "8": "#248797", "9": "#228e8f", "10": "#289787", "11": "#35a37e", "12": "#42af75", "13": "#4eba6d", "14": "#5bc764", "15": "#76cd59", "16": "#91d34e", "17": "#afd843", "18": "#ccde38", "19": "#e8e32d", "20": "#fde830", "21": "#feec55", "22": "#fef077", "23": "#fff49d", "24": "#fff9cb", "25": "#ffffff"}, "id_variable": "lwt", "range_map": {"1": {"min": 1500, "max": 5600}, "2": {"min": 1438, "max": 1500}, "3": {"min": 1375, "max": 1438}, "4": {"min": 1312, "max": 1375}, "5": {"min": 1250, "max": 1312}, "6": {"min": 1188, "max": 1250}, "7": {"min": 1125, "max": 1188}, "8": {"min": 1062, "max": 1125}, "9": {"min": 1000, "max": 1062}, "10": {"min": 938, "max": 1000}, "11": {"min": 875, "max": 938}, "12": {"min": 812, "max": 875}, "13": {"min": 750, "max": 812}, "14": {"min": 688, "max": 750}, "15": {"min": 625, "max": 688}, "16": {"min": 562, "max": 625}, "17": {"min": 500, "max": 562}, "18": {"min": 438, "max": 500}, "19": {"min": 375, "max": 438}, "20": {"min": 312, "max": 375}, "21": {"min": 250, "max": 312}, "22": {"min": 188, "max": 250}, "23": {"min": 125, "max": 188}, "24": {"min": 62, "max": 125}, "25": {"min": 0, "max": 62}}}
            cm['map'] = map;
            commit('SET_MAP_LEGEND', cm);
        } else {
            axios
                .get(
                    //_BASE_URL_LEGEND + "/" + variable.variable + "/geoid/default/unit/" + variable.unit
                    _BASE_URL_LEGEND + "/" + variable + "/unit/" + unit //state.menuSettings.variable.unit
                )
                .then(response => {
                    if (response.status == 200) {
                        response.data['map'] = map;
                        commit('SET_MAP_LEGEND', response.data);
                    } else {
                        commit('SET_MAP_LEGEND', {});
                    }
                })
                .catch(e => {
                    commit('SET_MAP_LEGEND', undefined);
                    console.log(e);
                });
        }
    },


    getPixelStats({ rootState, commit }, { latitude, longitude, startDate, endDate, variables }) {

        const signal = activeRequestController ? activeRequestController.signal : null;

        let urls = [];

        for (let i = 0; i < variables.length; i++) {
            if (variables[i].id == "") continue;

            // TODO - PROCESS model stats
            // if (variables[i].type == 'model') {
            //     dispatch('getModelData', {latitude, longitude, startDate, endDate, variables} );
            //     continue;
            // }
            if (rootState.variables.variables[variables[i].id].type != 'model') {
                let url = _BASE_URL_PIXEL + 'stats/lat/' + latitude + '/lon/' + longitude + '/from/' + startDate + '/to/' + endDate + '?';
                url += ('&var[eq]=' + variables[i].id)
                if (variables[i].threshold != null)
                    url += variables[i].threshold
                urls.push(url);
            }
        }

        if (urls.length > 0) {
            // commit('SET_DATA_LOADING', true);
            return axios.all(urls.map(ur => axios.get(ur, { signal, timeout: 15000 })))
                .then(response => {
                    let ret = []
                    response.forEach(element => {
                        ret.push(element.data.data)
                    });
                    commit('SET_PIXEL_STATS', ret);
                    // commit('SET_DATA_LOADING', false);
                })
                .catch((e) => {
                    if (e.code === 'ECONNABORTED' && e.message.includes('timeout')) {
                        console.error("The Stats API took longer than 15 seconds and timed out!");
                    }
                    else console.log("Error on Form: ", e);
                    throw e;
                });
        }

    },


    getPixelSeasonsSummaryDashboard({ rootState, commit }, { latitude, longitude, startDate, endDate, variables }) {
        const signal = activeRequestController ? activeRequestController.signal : null;

        if (startDate == undefined || latitude == undefined) return;

        //
        startDate = '1981-' + startDate.split('-')[1] + '-' + startDate.split('-')[2];
        // endDate = new Date().getFullYear() + '-' + endDate.split('-')[1] + '-' + endDate.split('-')[2];

        var endYear = new Date().getFullYear();

        if (Number(endDate.split('-')[1]) > (new Date().getMonth() + 1))
            endYear = new Date().getFullYear() - 1;

        endDate = endYear + '-' + endDate.split('-')[1] + '-' + endDate.split('-')[2];

        let url = _BASE_URL_PIXEL + 'pixel/lat/' + latitude + '/lon/' + longitude + '/from/' + startDate + '/to/' + endDate + '?'

        for (let i = 0; i < variables.length; i++) {

            if (rootState.variables.variables[variables[i].id].type != 'model') {
                // Historical query
                url += ('&var[eq]=' + variables[i].id)
                if (variables[i].threshold != null && variables[i].threshold != "1")
                    url += variables[i].threshold;
            }
        }
        url += '&reduce=sum';
        commit('SET_SEASON_SUMMARY', [])
        return axios.get(url, { signal, timeout: 15000 })
            .then((response) => {
                commit('SET_SEASON_SUMMARY', response.data.data)
            })
            .catch((e) => {
                console.log("Error on Form: ", e);
            });
    },

    getPixelSeasonSummaryData({ commit, dispatch }, { latitude, longitude, startDate, endDate, variables }) {

        if (startDate == undefined || latitude == undefined) return;

        //

        let urls = [];

        for (let i = 0; i < variables.length; i++) {

            if (variables[i].type == 'model') {
                const deviation = true;
                const agg = '1D';
                dispatch('getModelData', { latitude, longitude, startDate, endDate, agg, variables, deviation });
            } else {

                // Historical query
                startDate = '1981-' + startDate.split('-')[1] + '-' + startDate.split('-')[2];
                endDate = new Date().getFullYear() + '-' + endDate.split('-')[1] + '-' + endDate.split('-')[2];

                let url = _BASE_URL_PIXEL + 'pixel/lat/' + latitude + '/lon/' + longitude + '/from/' + startDate + '/to/' + endDate + '?'
                url += ('&var[eq]=' + variables[i].id)
                // console.log('add url: ', url)
                if (variables[i].threshold != null && variables[i].threshold != "1")
                    url += variables[i].threshold
                url += '&reduce=sum'
                urls.push(url);
            }
        }

        if (urls.length > 0)
            axios.get(urls[0])
                .then((response) => {
                    commit('SET_SEASON_SUMMARY', response.data.data)
                })
                .catch((e) => {
                    console.log("Error on Form: ", e);
                });
    },

    getModelData({ rootState, commit }, { latitude, longitude, startDate, endDate, agg, variables, deviation = false, raw = false }) {
        const signal = activeRequestController ? activeRequestController.signal : null;

        startDate = startDate.split('-');
        endDate = endDate.split('-');
        startDate = startDate[0] + startDate[1] + startDate[2];
        endDate = endDate[0] + endDate[1] + endDate[2];
        let allpromises = [];


        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        const yesterdayStr = yesterday.getFullYear() +
            String(yesterday.getMonth() + 1).padStart(2, '0') +
            String(yesterday.getDate()).padStart(2, '0');

        for (let i = 0; i < variables.length; i++) {

            if (variables[i].type == 'model') {

                const vs = [variables[i].id];

                if (!deviation && !raw) {
                    if (rootState.variables.variables[variables[i].id + 'His'] != undefined)
                        vs.push(variables[i].id + 'His');
                }
                
                vs.forEach(variable => {
                    const source = variable == 'arid' ? 'pixel' : 'acis';

                     let varEndDate = endDate;
                    // A period reaching the latest available day (or past it) also
                    // loads the Heat Index forecast: up to yesterday + 6 days.
                    if (variable == 'hi' && endDate >= yesterdayStr) {
                        const d = new Date(yesterday);
                        d.setDate(d.getDate() + 6);
                        varEndDate = d.getFullYear() +
                            String(d.getMonth() + 1).padStart(2, '0') +
                            String(d.getDate()).padStart(2, '0');
                    }
                    
                    let obj = {
                        "model": variable, //variables[0].id,
                        "threshold": variables[i].threshold,
                        "aggregation": agg,
                        "io": {
                            "source": source,
                            "interval": variables[i].dataObservation,
                            "latitude": latitude,
                            "longitude": longitude,
                            "begin": variables[i].dataObservation == 'hourly' ? (startDate + '00') : startDate,
                            "end": variables[i].dataObservation == 'hourly' ? (varEndDate + '23') : varEndDate,
                            //"end": variables[i].dataObservation == 'hourly' ? (endDate + '23') : endDate,
                            "timezone": -5
                        }
                    }
                    if (deviation)
                        obj['reduce'] = 'sum';

                    // commit('SET_DATA_LOADING', true);
                    //axios.post(_BASE_URL_PIXEL_MODEL + variables[0].id, obj)
                    let req = axios.post(_BASE_URL_PIXEL_MODEL + variable, obj, { signal, timeout: 15000 })
                        .then(response => {
                            let arr = [];

                            if (response.data.code.toLowerCase() != 'error') {
                                let rows = withoutNoData(response.data.data);
                                // Keep only the requested period (forecast days included):
                                // the model API has answered long periods with other dates.
                                if (!deviation && variable == variables[i].id && Array.isArray(rows)) {
                                    rows = rows.filter(row => {
                                        const day = String(row.date).slice(0, 10).replace(/-/g, '');
                                        return day >= startDate && day <= varEndDate;
                                    });
                                }
                                arr.push(rows)
                                if (raw) return rows;
                                if (deviation)
                                    commit('SET_SEASON_SUMMARY', arr[0])
                                else {
                                    commit('SET_PIXEL_DATA', arr);
                                }
                                if ((variable == vs[1] && i == (variables.length - 1)) || deviation || (rootState.variables.variables[variables[i].id + 'His'] == undefined)) {
                                    // commit('SET_DATA_LOADING', false);
                                }
                            }
                            return raw ? null : undefined;
                        })
                        .catch(error => {
                            console.error("There was an error!", error);
                            if (raw) return null;
                        });
                    allpromises.push(req);
                });
            }
        }
        return Promise.all(allpromises);
    },

    // New getPixelData
    getPixelData({ commit, dispatch }, { latitude, longitude, startDate, endDate, agg, variables, raw = false }) {
        const signal = activeRequestController ? activeRequestController.signal : null;

        let urls = [];
        let modelDispatches = [];

        for (let i = 0; i < variables.length; i++) {
            if (variables[i].id == "") continue;

            if (variables[i].type == 'model') {
                if (!raw) modelDispatches.push(dispatch('getModelData', { latitude, longitude, startDate, endDate, agg, variables }));
                continue;
            }

            let url = _BASE_URL_PIXEL + 'pixel/lat/' + latitude + '/lon/' + longitude + '/from/' + startDate + '/to/' + endDate + '?agg=' + agg;
            url += ('&var[eq]=' + variables[i].id);
            if (variables[i].threshold != null) {
                url += variables[i].threshold;
            }
            urls.push(url);

            if (!raw) {
                let url_his = _BASE_URL_PIXEL + 'his/lat/' + latitude + '/lon/' + longitude + '/from/' + startDate + '/to/' + endDate + '?agg=' + agg;
                url_his += ('&var[eq]=' + variables[i].id);
                if (variables[i].threshold != null) {
                    url_his += variables[i].threshold;
                }
                urls.push(url_his);
            }
        }

        if (urls.length === 0) {
            if (raw) return Promise.resolve([]);
            return Promise.all(modelDispatches);
        }

        const mainrequest = axios.all(urls.map(ur => axios.get(ur, { signal, timeout: 15000 })))
            .then(response => {
                let ret = [];
                response.forEach(element => {
                    if (element.data.code.toLowerCase() != 'error') {
                        ret.push(withoutNoData(element.data.data));
                    }
                });
                if (raw) return ret;
                commit('SET_PIXEL_DATA', ret);
            })
            .catch(e => {
                console.log("Error on Form: ", e);
                throw e;
            });

        if (raw) return mainrequest;
        return Promise.all([mainrequest, ...modelDispatches]);
    },

    setDataLoading({ commit }, data) {
        commit('SET_DATA_LOADING', data);
    },

    // Shows the pre-loader until `promise` settles; resolves with its results
    // (Promise.allSettled), so a failed request never leaves it on.
    trackLoading({ commit }, promise) {
        commit('ADD_PENDING_LOADS', 1);
        return Promise.allSettled([].concat(promise))
            .finally(() => commit('ADD_PENDING_LOADS', -1));
    },

    setDataAnalysisFullScreen({ commit }, data) {
        commit('SET_DATAANALYSIS_FULLSCREEN', data);
    },


    setPixelData({ commit }, data) {
        commit('SET_PIXEL_DATA', data);
    },


    /*
     * Menu Control
    */
    setMenuSettings({ commit }, menu) {
        commit('SET_MENU_SETTINGS', menu);
    },

    setMenuLocale({ commit }, locale) {
        commit('SET_MENU_LOCALE', locale)
    },

    setMenuVariable({ commit }, menu) {
        commit('SET_MENU_VARIABLE', menu);
    },

    setMenuPeriod({ commit }, period) {
        commit('SET_MENU_PERIOD', period);
    },

    /*
     * Map Mode Control
    */
    setMapConfigOne({ commit }, config) {
        commit('SET_MAP_CONFIG_ONE', config);
    },

    setMapConfigTwo({ commit }, config) {
        commit('SET_MAP_CONFIG_TWO', config);
    },

    setLatLon({ commit }, latLon) {
        commit('SET_LAT_LON', latLon);
    },

    setDropPinStatus({ commit }, status) {
        commit('SET_DROP_PIN_STATUS', status);
    },

    setDataAnalysisStatus({ commit }, status) {
        commit('SET_DATA_ANALYSIS_STATUS', status);
    },

    /*
    * Alert control
    */
    setAlert({ commit }, alert) {
        commit('SET_NEW_ALERT', alert);
    },

    deleteAlert({ commit }, alert) {
        commit('DELETE_ALERT', alert);
    },

}

//to handle mutations
const mutations = {

    SET_GEO_INFO(state, data) {
        state.latLonInfo = data;
    },

    /*
    * Alert control
    */
    SET_NEW_ALERT(state, alert) {
        state.alerts.push(alert);
    },

    DELETE_ALERT(state, alert) {
        state.alerts = state.alerts.filter(element => element.message != alert.message);
    },

    /*
    * Pre-loader
    */
    SET_DATA_LOADING(state, data) {
        state.dataLoading = data;
    },

    ADD_PENDING_LOADS(state, delta) {
        state.pendingLoads = Math.max(0, state.pendingLoads + delta);
    },

    /*
     * Menu control
    */
    SET_MENU_SETTINGS(state, data) {
        state.menuSettings = data;
    },

    SET_MENU_LOCALE(state, data) {
        state.menuLocale = data;
    },

    SET_MENU_VARIABLE(state, data) {
        state.menuVariable = data;
    },

    SET_MENU_PERIOD(state, data) {
        state.menuPeriod = data;
    },

    /*
     * Map mode control
    */
    SET_MAP_CONFIG_ONE(state, data) {
        state.mapConfigOne = data;
    },

    SET_MAP_CONFIG_TWO(state, data) {
        state.mapConfigTwo = data;
    },

    /*
     * Map mode control
    */
    SET_MAP_LEGEND(state, data) {
        if (!data) {
            state.mapLegend.map1 = { colors: [], values: [], layer: '' };
            state.mapLegend.map2 = { colors: [], values: [], layer: '' };
            return;
        }
        const { map, color_map, range_map, id_variable } = data;
        const keys = Object.keys(color_map).map(Number);
        const legend = { colors: [], values: [], layer: id_variable };

        keys.forEach(key => {
            legend.colors.push(color_map[key]);

            if (range_map[key]) {
                if (key === Math.min(...keys)) {
                    legend.values.push('more');
                    legend.values.push(range_map[key].min); // Add max value for the last key
                    legend.colors.push(color_map[key]);

                } else if (!id_variable.includes('totR') && key === Math.max(...keys)) {
                    legend.values.push('less');
                } else {
                    legend.values.push(range_map[key].min);
                }
            }
        });

        legend.colors.reverse();

        if (id_variable === 'arid') {
            legend.values = [1, 0.9, 0.8, 0.7, 0.6, 0.5, 0.4, 0.3, 0.2, 0.1, 0];
        }

        legend.values.reverse();
        state.mapLegend[map] = legend;

    },

    SET_DROP_PIN_STATUS(state, data) {
        state.dropPinStatus = data;
    },

    SET_DATAANALYSIS_FULLSCREEN(state, data) {
        state.dataAnalysisFullScreen = data;
    },

    SET_DATA_ANALYSIS_STATUS(state, data) {
        state.dataAnalysisStatus = data;
    },

    SET_LAT_LON(state, data) {
        state.mapLatLon = data;
    },

    SET_SEASON_SUMMARY(state, data) {

        //state.pixelSeasonSummary = data;

        //console.log('SET_PIXEL_DATA: ', data)
        if (data.length > 0) {

            const map = new Map();

            if (state.pixelSeasonSummary.length > 0) {
                state.pixelSeasonSummary.forEach(item => map.set(item.date, item));
                data.forEach(arr2 => {
                    arr2.forEach(item => map.set(item.date, { ...map.get(item.date), ...item }));
                });
                state.pixelSeasonSummary = [];
            } else {

                // let arr1 = data.shift();
                // arr1.forEach(item => map.set(item.date, item));

                data.forEach(item => {
                    map.set(item.date, { ...map.get(item.date), ...item });
                });

                // data.forEach(arr2 => {
                //     arr2.forEach(item => map.set(item.date, {...map.get(item.date), ...item}))
                // });
            }

            Array.from(map.values()).forEach(item => {
                state.pixelSeasonSummary.push(item);
            });

        } else {
            // Clear array
            state.pixelSeasonSummary = [];
        }

    },

    SET_PIXEL_STATS(state, data) {
        // state.pixelStats = data;
        if (data.length > 0) {
            let obj = state.pixelStats;
            data.forEach(item => {
                let keys = Object.keys(item);
                keys.forEach(key => obj[key] = item[key]);
            });
            state.pixelStats = Object.assign({}, state.pixelStats, obj)
        } else {
            state.pixelStats = [];
        }
    },

    SET_PIXEL_DATA(state, data) {

        if (data.length > 0) {

            const map = new Map();

            if (state.pixelData.length > 0) {
                state.pixelData.forEach(item => map.set(item.date, item));
                data.forEach(arr2 => {
                    arr2.forEach(item => map.set(item.date, { ...map.get(item.date), ...item }));
                });
                state.pixelData = [];
            } else {
                let arr1 = data.shift();

                arr1.forEach(item => map.set(item.date, item));
                data.forEach(arr2 => {
                    arr2.forEach(item => map.set(item.date, { ...map.get(item.date), ...item }));
                });
            }

            Array.from(map.values()).forEach(item => {
                state.pixelData.push(item);
            });

        } else {
            // Clear array
            state.pixelData = [];
        }
    },

    // SET_YEARS_AVG_DATA(state, data) {
    //     state.fiveYearsData = [];
    //     data.forEach(element => {
    //         { x: [], y: [] }
    //         state.fiveYearsData.push()
    //     })
    // }

}

//export store module
import variable_module from './modules/variables';
import ws_module from "./modules/ws";
import map_module from "./modules/map";
import notifications_module from "./modules/notifications";
import social_module from "./modules/social";
import pixel_module from "./modules/pixel";
import risk_module from "./modules/risk";

export default new Vuex.Store({
    state,
    getters,
    actions,
    mutations,
    modules: {
        variables: variable_module,
        ws: ws_module,
        map: map_module,
        notifications: notifications_module,
        social: social_module,
        pixel: pixel_module,
        risk: risk_module,
    }
})